<template>
  <main class="login-page">
    <section class="login-panel">
      <router-link to="/" class="site-brand">
        <BrandLogo />
      </router-link>
      <h1>Redefinir senha</h1>
      <p>Use o código de 6 dígitos recebido para criar uma nova senha.</p>

      <v-form @submit.prevent="submit">
        <v-text-field v-model="email" label="Email corporativo" outlined dense />
        <v-text-field v-model="code" label="Código de 6 dígitos" outlined dense maxlength="6" />
        <v-text-field v-model="password" label="Nova senha" type="password" outlined dense />
        <v-alert v-if="message" type="success" dense text>{{ message }}</v-alert>
        <v-alert v-if="error" type="error" dense text>{{ error }}</v-alert>
        <v-btn block color="primary" height="44" type="submit" :loading="loading">Redefinir senha</v-btn>
      </v-form>

      <div class="auth-links">
        <router-link to="/recuperar-senha">Solicitar novo código</router-link>
        <router-link to="/login">Voltar ao login</router-link>
      </div>
    </section>
  </main>
</template>

<script>
import api from '../../plugins/axios'
import BrandLogo from '../../components/BrandLogo.vue'

export default {
  name: 'ResetPasswordPage',
  components: {
    BrandLogo
  },
  data () {
    return {
      email: this.$route.query.email || '',
      code: '',
      password: '',
      loading: false,
      message: '',
      error: ''
    }
  },
  methods: {
    async submit () {
      this.loading = true
      this.message = ''
      this.error = ''

      try {
        await api.post('/auth/password/reset', {
          email: this.email,
          code: this.code,
          password: this.password
        })
        this.message = 'Senha redefinida com sucesso.'
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Não foi possível redefinir a senha.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
